export const buildEndpointUrl = (baseUrl: string, endpoint: string, pathVariables: Record<string, string | number>, query: object) => {
  const pathSubstituted = Object.entries(pathVariables).reduce(
    (url, entry) => url.replace(`{${entry[0]}}`, entry[1]?.toString() ?? ""),
    endpoint,
  );
  const queryParamsString = buildQueryParamsString(query);

  return [
    baseUrl.endsWith("/") && endpoint.startsWith("/") ? baseUrl.slice(0, -1) : baseUrl,
    pathSubstituted,
    queryParamsString.length ? `?${queryParamsString}` : "",
  ].join("");
};

const buildQueryParamsString = (query: object) => {
  const queryParams: Record<string, string> = {};

  const addQueryParams = (obj: object, prefix: string) => {
    for (const [key, value] of Object.entries(obj)) {
      if (value === undefined || value === null) {
        continue;
      }

      if (Array.isArray(value)) {
        queryParams[`${prefix}${key}`] = value.join(",");
      } else if (typeof value === "object") {
        addQueryParams(value, `${prefix}${key}.`);
      } else {
        queryParams[`${prefix}${key}`] = value.toString();
      }
    }
  };

  addQueryParams(query, "");

  const searchParams = new URLSearchParams(queryParams);
  searchParams.sort();

  return searchParams.toString();
};
